module.exports = __webpack_public_path__ + "media/images/Cart_Navy_2x-ca55d9a2.png";